import { TileGrid } from "../sections/main/tile-grid/TileGrid";

export default function OurWork() {
  return <TileGrid />;
}
